import api from './api';
import { debugLog, debugWarn, debugError } from '../utils/logger';

// Fallback minimo (solo STUN publico) por si el backend/Twilio NTS no
// responde. Sin TURN el video puede fallar en redes con NAT simetrico, pero
// es mejor tener STUN que dejar iceServers vacio.
const STUN_ONLY_FALLBACK = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' }
];

// Obtiene credenciales STUN/TURN desde el backend (Twilio Network Traversal
// Service). VideoCallModal la llama al montar, para que las credenciales ya
// esten listas cuando el usuario inicie o conteste la llamada.
export const getIceServers = async () => {
  try {
    const { data } = await api.get('/webrtc/ice-servers');
    if (Array.isArray(data?.iceServers) && data.iceServers.length > 0) {
      debugLog('🧊 [webrtcService] ICE servers obtenidos, fuente:', data.source);
      return data.iceServers;
    }
    debugWarn('⚠️ [webrtcService] Respuesta sin iceServers validos, usando fallback STUN-only');
    return STUN_ONLY_FALLBACK;
  } catch (err) {
    debugError('❌ [webrtcService] Error obteniendo ICE servers:', err.message);
    return STUN_ONLY_FALLBACK;
  }
};
